import classNames from "classnames";

import { Icon } from "@livingmap/hippo";
import styles from "./SelectorButton.module.scss";

interface Props {
  isOpen?: boolean | undefined;
  activeProject: string | undefined;
}

const SelectorButton: React.FC<Props> = ({ isOpen, activeProject }) => {
  return (
    <button data-qa="project-selector-button" className={styles.button}>
      <span className={styles.buttonText}>{activeProject}</span>
      {isOpen !== undefined && (
        <Icon
          dataQA="open-icon"
          name="chevron_down"
          size={24}
          className={classNames({
            [styles.open]: isOpen,
          })}
        />
      )}
    </button>
  );
};

export default SelectorButton;
